import { render, staticRenderFns } from "./SMSSetting.vue?vue&type=template&id=01c9b1a0&"
import script from "./SMSSetting.vue?vue&type=script&lang=js&"
export * from "./SMSSetting.vue?vue&type=script&lang=js&"
import style0 from "./SMSSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports